import resolveResponse from 'contentful-resolve-response'
import fetchQueryWrapper from '../../network/fetchQueryWrapper'
import { getCollectionParams } from '../../network/queryParams'
import { CONTENT_TYPE } from '../../utils/contentTypes'
import logger from '../../utils/winston-logger/winston-logger'
import extractCategoryInternals from '../../data/transformers/extractCategoryInternals'
import extractStoryCollection from '../../data/transformers/extractStoryCollection'
import CategoryDetails from '../../components/Category/CategoryDetails'

const Category = ({ category, collection }) => <CategoryDetails category={category} collection={collection} />

export async function getServerSideProps(ctx) {
  try {
    const categoryInternals = await fetchQueryWrapper(
      {
        content_type: CONTENT_TYPE.CATEGORY,
        'fields.slug': ctx?.query?.slug
      },
      resolveResponse
    )

    const category = extractCategoryInternals(categoryInternals)
    const storyCollection = await fetchQueryWrapper(getCollectionParams({ categoryId: category.id }), resolveResponse)
    const collection = extractStoryCollection(storyCollection)

    return { props: { category, collection } }
  } catch (error) {
    logger.error('Error in categories/[slug].page.js ', error)
    return { notFound: true }
  }
}

export default Category
